
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useMemo } from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from '../../components/Layout';
import { Namespace } from '../../enums/namespaces';
import { StaticPathParams } from '../../typings/staticPaths';
import Head from 'next/head';
import { basicSEO } from 'helpers/jsx';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { createRedirectIfNeeded } from 'helpers';
import { Country } from '../../enums/country';
import { ScheduleItem } from 'typings/notGenerated';
import { useLang } from 'context/langContext';

interface Props {
  items: ScheduleItem[];
  countryCode: string;
}

const BroadCast: NextPage<Props> = ({ items, countryCode }: Props) => {
  const { t } = useTranslation(Namespace.Broadcast);
  const { locale } = useLang();

  const formattedItems = useMemo(() => {
    const dayMap: { [index: string]: ScheduleItem[] } = {};
    items.forEach((i) => {
      const formattedDate = new Date(i.premiere).toLocaleDateString(locale);
      dayMap[formattedDate] = dayMap[formattedDate] ?? [];
      dayMap[formattedDate].push(i);
    });
    return dayMap;
  }, [items]);

  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:broadcast_title'), t('seo:broadcast_description'))}</Head>
      <main className={styles.broadcast}>
        <div>
          <h1>{t('broadcast:broadcast_title')}</h1>
          <div className={styles.video}>
            <span>{t('broadcast:video_placeholder')}</span>
          </div>
        </div>
        <div className={styles.schedule}>
          <h2>{t('broadcast:schedule_title')}</h2>
          {Object.keys(formattedItems).map((dayStamp) => (
            <div key={dayStamp}>
              <h3>{dayStamp}</h3>
              <ul className={styles.list}>
                {formattedItems[dayStamp].map((i) => (
                  <li key={i.id}>
                    <div>
                      <h4 itemProp="play">{i.title}</h4>
                      <h5 itemProp="theatre">{i.theatre_title}</h5>
                    </div>
                    <time>{new Date(i.premiere).toLocaleTimeString(locale, { timeStyle: 'short' })}</time>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  if (countryCode !== Country.Czechia) {
    return {
      notFound: true,
    };
  }

  const items = await apiClient.getBroadcastSchedule();

  return {
    props: {
      items,
      countryCode,
    },
  };
}

export default BroadCast;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/broadcast/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  